import styled, { css } from 'styled-components';
import colors from '../../../../../helpers/colors';
import fonts from '../../../../../helpers/fonts';
import spacing, { spacingWithBorder } from '../../../../../helpers/spacing';
import { baseSectionItemStyles, eventStyles } from '../styles';

const menuSeparator = css`
  border-top: solid 1px ${colors.neutral08};
`;

export const SectionHeading = styled.h3`
  ${baseSectionItemStyles}
  ${fonts.headingXSmall}
  & {
    color: ${colors.core02};
  }

  margin: 0;
  padding: ${spacing(1.5)} ${spacing(2)};
`;

export const SectionLinks = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

export const SectionLink = styled.a`
  ${baseSectionItemStyles}

  ${fonts.paragraph}

  background-color: ${colors.neutral06};
  text-decoration: none;
  outline: none;

  ${eventStyles(colors.core02)}
`;

export const SectionLinkWrapper = styled.li`
  background-color: ${colors.neutral06};

  :not(:first-child) {
    ${menuSeparator}

    ${SectionLink} {
      padding-top: ${spacingWithBorder(2, 1)};
    }
  }
`;

export const CardSectionContainer = styled.div`
  padding: ${spacing(2)} ${spacing(3)};
  background-color: ${colors.core03};

  :not(:first-child) {
    ${menuSeparator};
  }
`;

export const IconWrapper = styled.span`
  display: none;
`;
